export const backgroundColor: string[] = ['#287da1','#6ba4b8','#8d9093','#1B365D','rgba(0, 0, 0, 0.87)'];

export const railCarAgeData = {
  labels: ['0-5', '6-10', '11-15', '16-20', '21+'],
  datasets: [{ backgroundColor, data: [ 41, 22, 12, 2, 1 ] }],
};

export const complianceDueData = {
  labels: ['2022', '2023', '2024', '2025', '2026'],
  datasets: [{ backgroundColor, data: [ 41, 22, 12, 2, 1 ] }],
};

export const chartOptions = {
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
  scales: {
    x: {
      drawBorder: false,
      ticks: { color: '#676b6f' },
      grid: {
        drawBorder: false,
        color: 'transparent'
      }
    },
    y: {
      suggestedMin: 0,
      suggestedMax: 50,
      ticks: {
        color: '#676b6f',
        maxTicksLimit: 6,
        padding: 7,
        display: false
      },
      grid: { drawBorder: false },
    },
  }
};
